export const LAST_REVIEWED = "August 2026";

export const KNOWN_LIMITATIONS: string[] = [
  "This statement reflects our own internal review against WCAG 2.1 AA — a formal third-party accessibility audit has not yet been conducted.",
  "Some embedded third-party content (e.g. Wikimedia Commons photography) is outside our direct control and may not fully meet the same standard.",
];
